var _a;
export var Elevation;
(function (Elevation) {
    Elevation["DEPTH1"] = "depth1";
    Elevation["DEPTH2"] = "depth2";
    Elevation["DEPTH3"] = "depth3";
    Elevation["DEPTH4"] = "depth4";
    Elevation["DEPTH5"] = "depth5";
    Elevation["DEPTH6"] = "depth6";
    Elevation["DEPTH7"] = "depth7";
    Elevation["DEPTH8"] = "depth8";
    Elevation["DEPTH9"] = "depth9";
    Elevation["DEPTH10"] = "depth10";
    Elevation["LOCAL_SCROLL"] = "local-scroll";
    Elevation["MOBILE_0"] = "mobile0";
    Elevation["MOBILE_1"] = "mobile1";
    Elevation["MOBILE_2"] = "mobile2";
    Elevation["MOBILE_3"] = "mobile3";
})(Elevation || (Elevation = {}));
var elevation = (_a = {},
    _a[Elevation.DEPTH1] = '0px 0px 20px rgba(0, 0, 0, 0.07)',
    _a[Elevation.DEPTH2] = '0px 0px 40px rgba(0, 0, 0, 0.07)',
    _a[Elevation.DEPTH3] = '0px 9px 47px rgba(0, 0, 0, 0.07), 0px 3.46667px 14.9704px rgba(0, 0, 0, 0.0425185), 0px 0.733333px 3.82963px rgba(0, 0, 0, 0.0274815)',
    _a[Elevation.DEPTH4] = '0px 20px 96px rgba(0, 0, 0, 0.07), 0px 7.7037px 30.5778px rgba(0, 0, 0, 0.0425185), 0px 1.62963px 7.82222px rgba(0, 0, 0, 0.0274815)',
    _a[Elevation.DEPTH5] = '0px 0px 54px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.05)',
    _a[Elevation.DEPTH6] = '0px 9px 179px rgba(0, 0, 0, 0.07), 0px 3.46667px 57.0148px rgba(0, 0, 0, 0.0668148)',
    _a[Elevation.DEPTH7] = '0px 40px 201px rgba(110, 41, 136, 0.08), 0px 15.4074px 64.0222px rgba(110, 41, 136, 0.0485926), 0px 3.25926px 16.3778px rgba(110, 41, 136, 0.0314074)',
    _a[Elevation.DEPTH8] = '0px 4px 24px rgba(0, 0, 0, 0.07)',
    _a[Elevation.DEPTH9] = 'inset 0px -1px 0px rgb(233, 233, 233)',
    _a[Elevation.DEPTH10] = '0px 4px 16px 0px rgba(185, 183, 187, 0.13)',
    _a[Elevation.LOCAL_SCROLL] = 'linear-gradient(white, rgba(255, 255, 255, 0)), linear-gradient(rgba(255, 255, 255, 0), white) 0 100%, linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05)) 0 100%',
    _a[Elevation.MOBILE_0] = 'none',
    _a[Elevation.MOBILE_1] = '0px 0px 4px rgba(51, 51, 51, 0.06), 0px 1px 12px rgba(99, 99, 99, 0.06), 0px 2px 24px rgba(221, 221, 221, 0.24)',
    _a[Elevation.MOBILE_2] = '0px 2px 12px rgba(150, 150, 150, 0.16), 0px 0px 24px rgba(221, 221, 221, 0.24)',
    _a[Elevation.MOBILE_3] = '0px 2px 16px rgba(17, 17, 17, 0.1), 0px 4px 32px rgba(31, 31, 31, 0.06)',
    _a);
export default elevation;
